import { emitRecoAddToCartButtonLabelEvent } from "./eventEmitter";

export default () => {
    const event = {
        name: "scroll",
    };

    emitRecoAddToCartButtonLabelEvent({ promo_RecoAddToCartButton: "visible" }, event);
};
